import React, { useEffect, useState, useMemo } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Col, Form, Row } from "react-bootstrap";
import axios from "axios";

export interface IDeliveryDateForm {
  desired_delivery_date: Date|undefined;
  desired_delivery_timezone: string;
};

interface IProps {
  timezones: { [key: string]: string };
  onChange: (val: IDeliveryDateForm) => void;
  values: IDeliveryDateForm;
};

/* 完全にサーバーの時間を用いてもいいが、ある程度追随させる */
type BaseTime = {
  server: Date,
  client: Date
}
const getRoughlyServerTime = (b: BaseTime) => {
  const diff = b.server.getTime() - b.client.getTime()
  const now = new Date().getTime()
  return new Date(now + diff)
}
const getJSTHour = (d: Date) => {
  const format = new Intl.DateTimeFormat("ja-JP", {timeZone: "Asia/Tokyo", hour: "2-digit", hour12: false})
  const hour = parseInt(format.format(d), 10)
  return hour
}

const DeliveryDateForm = (props: IProps) => {
  const [date, setDate] = useState<Date|undefined>(props.values.desired_delivery_date);
  const [timezone, setTimezone] = useState<string>(props.values.desired_delivery_timezone);

  const [baseTime, setBaseTime] = useState<BaseTime>({server: new Date(), client: new Date()})

  const addDate = (date: Date, add: number): Date => {
    date.setDate(date.getDate() + add);
    return date;
  };

  /* 14時を過ぎていた場合は1日追加する */
  const minDate = useMemo(() => addDate(getRoughlyServerTime(baseTime), 1 + Number(getJSTHour(getRoughlyServerTime(baseTime)) >= 14 )), [baseTime]);
  const maxDate = useMemo(() => addDate(getRoughlyServerTime(baseTime), 8), [baseTime]);

  useEffect(() => {
    props.onChange({ desired_delivery_date: date, desired_delivery_timezone: timezone });
  }, [date, timezone]);

  useEffect(() => {
    const date = new Date()
    axios.get(`/${window.gon.locale}/api/timezones/now`).then((body) => {
      setBaseTime({
        server: new Date(body.data.now),
        client: date
      })
    })
  }, [])

  const handleOnChangeTimezones = (e: React.ChangeEvent<HTMLInputElement>) => setTimezone(e.target.value);
  const onDateChange = (dateOrArr, _e) => {
    setDate(dateOrArr);
  };

  return (
    <Form.Group>
      <Form.Label> 配達希望日 </Form.Label>
      <Row>
        <Col>
          <DatePicker dateFormat="yyyy/MM/dd"
            selected={date}
            onChange={onDateChange}
            minDate={minDate}
            maxDate={maxDate}
            isClearable
            className="form-control" />
        </Col>
        <Col>
          <Form.Control as="select" onChange={handleOnChangeTimezones} custom>
            <option value="">指定なし</option>
            {Object.keys(props.timezones).map(key => (<option value={key} key={key}>{props.timezones[key]}</option>))}
          </Form.Control>
        </Col>
      </Row>
    </Form.Group>
  );
};

export default React.memo(DeliveryDateForm);
